// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"394":"codebuild","640":"pipelines"}[chunkId] + "." + {"394":"f7248f4d","640":"781acd82"}[chunkId] + ".js";
};